module.exports = __webpack_public_path__ + "static/media/overview6_0.793c910e.png";